'use client';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import SvgClose from '@/components/shared/SvgClose';

const SvgOpen = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 5v14M5 12h14"
      />
    </g>
  </svg>
);

const ArticleTable = () => {
  const [tableOpen, setTableOpen] = useState(true);
  const [articleHeadings, setArticleHeadings] = useState([]);

  function getTableOfContents() {
    const articleContent = document.getElementById('article-content');
    const faqSection = document.getElementById('article-faq');

    let allHeadings = [];

    if (articleContent) {
      allHeadings = [...articleContent.querySelectorAll('h2')];
    }

    if (faqSection) {
      const faqHeading = faqSection.querySelector('h2');

      if (faqHeading) {
        allHeadings.push(faqHeading);
      }
    }

    const headingsData = allHeadings.map((heading, index) => {
      const id = `heading-${index}`;

      heading.setAttribute('id', id);
      heading.classList.add('article-heading');

      return {
        id,
        text: heading.innerText
      };
    });

    setArticleHeadings(headingsData);
  }

  //set table of contents open/closed
  function handleToggle(e) {
    e.preventDefault();
    setTableOpen(!tableOpen);
  }

  useEffect(() => {
    getTableOfContents();
  }, []);

  return (
    <div
      id="table-of-contents"
      className={`border-dawn-grey-60 mx-4 mb-15 border px-6 sm:mx-0 ${!articleHeadings.length ? 'hidden' : ''}`}
    >
      <div className="py-5">
        <div className="flex justify-between">
          <p className={`sh12 sm:sh11`}>Table of Contents</p>
          {tableOpen ? (
            <button
              id="table-contents-toggle"
              className="self-start"
              aria-label="Toggle table of contents expanded"
              aria-expanded="true"
              role="button"
              onClick={(e) => handleToggle(e)}
            >
              <SvgClose stroke={'#000000'} type="-" />
            </button>
          ) : (
            <button
              id="table-contents-toggle"
              className="self-start"
              aria-label="Toggle table of contents collapsed"
              aria-expanded="false"
              role="button"
              onClick={(e) => handleToggle(e)}
            >
              <SvgOpen />
            </button>
          )}
        </div>
        <div
          className={`${
            tableOpen ? 'max-h-screen duration-600' : 'duration-200'
          } max-h-0 overflow-hidden transition-all`}
        >
          <ol className="mt-6">
            {articleHeadings?.map((heading, index) => {
              return (
                <li
                  key={index}
                  className="body-s sm:body-r hover:text-cozy-cognac mb-1 min-h-[24px] pl-4 last-of-type:mb-0"
                >
                  <Link
                    title={heading.text}
                    href={`#heading-${index}`}
                    prefetch={false}
                    className="inline-block"
                  >
                    <span className="pr-2">{index + 1}.</span> {heading.text}
                  </Link>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default ArticleTable;
